import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import CSS from 'csstype';
import s from './realPhoto.module.scss';

import StarsRaiting from '../starsRaiting';

import realPhotoV2Female1 from './img/realV2-female-before.jpg';
import realPhotoV2Female2 from './img/realV2-female-after.jpg';
import realPhotoV2Male1 from './img/realV2-male-before.jpg';
import realPhotoV2Male2 from './img/realV2-male-after.jpg';
import { useT } from '@hooks';
import { appStore } from '@store';
import { GENDER } from 'types';
interface RealPhotoProps {
	bgColor?: string;
	femaleBeforeImg?: string;
	femaleAfterImg?: string;
	femaleWeightBefore?: string;
	femaleWeightAfter?: string;
	femaleLost?: string;
	femaleDescription?: string;
	femaleName?: string;
	maleBeforeImg?: string;
	maleAfterImg?: string;
	maleWeightBefore?: string;
	maleWeightAfter?: string;
	maleLost?: string;
	maleDescription?: string;
	maleName?: string;
	stars?: number[];
	data?: string;
	noGender?: boolean;
	onlyImages?: boolean;
}

const RealPhoto: FC<RealPhotoProps> = observer(props => {
	const { T } = useT();
	const {
		bgColor = '#fff',
		stars,
		femaleBeforeImg = realPhotoV2Female1,
		femaleAfterImg = realPhotoV2Female2,
		femaleWeightBefore = 'January 2022',
		femaleWeightAfter = 'December 2022',
		femaleLost = 'lost 47 lb',
		femaleDescription = T('daypayback_review_text_4'),
		femaleName = T('daypayback_review_name_4'),
		maleBeforeImg = realPhotoV2Male1,
		maleAfterImg = realPhotoV2Male2,
		maleWeightBefore = 'January 2022',
		maleWeightAfter = 'December 2022',
		maleLost = 'lost 47 lb',
		maleDescription = T('daypayback_review_text_3'),
		maleName = 'Jean_leon1',
		data = '25 December 2022',
		noGender,
		onlyImages = false,
	} = props;
	const mainBg: CSS.Properties = { background: bgColor };

	// FIXME: must be refactored by removing gender and move pictures, texts into model and pass it in props
	const { gender } = appStore.params;

	const textData = [
		{
			title: femaleName,
			description: femaleDescription,
			weightBefore: femaleWeightBefore,
			weightAfter: femaleWeightAfter,
			lost: femaleLost,
		},
		{
			title: maleName,
			description: maleDescription,
			weightBefore: maleWeightBefore,
			weightAfter: maleWeightAfter,
			lost: maleLost,
		},
	];

	let titleMain = textData[0].title;
	let description = textData[0].description;
	let weightBefore = textData[0].weightBefore;
	let weightAfter = textData[0].weightAfter;
	let lost = textData[0].lost;

	let imgSrcBefore = femaleBeforeImg;
	let imgSrcAfter = femaleAfterImg;

	if (!noGender && gender === GENDER.MALE) {
		imgSrcBefore = maleBeforeImg;
		imgSrcAfter = maleAfterImg;
		titleMain = textData[1].title;
		description = textData[1].description;
		weightBefore = textData[1].weightBefore;
		weightAfter = textData[1].weightAfter;
		lost = textData[1].lost;
	}

	return (
		<>
			{onlyImages ? (
				<div className={s.realPhoto_imgs}>
					<div className={s.realPhoto_imgWrapper}>
						<img className={s.realPhoto_imgWrapper_img} src={imgSrcBefore} alt='before' />
						<div className={s.realPhoto_weight}>{weightBefore}</div>
					</div>
					<div className={s.realPhoto_imgWrapper}>
						<img className={s.realPhoto_imgWrapper_img} src={imgSrcAfter} alt='after' />
						<div className={s.realPhoto_weight_after}>{weightAfter}</div>
					</div>
				</div>
			) : (
				<div className={s.realPhoto_container} style={mainBg}>
					<div className={s.realPhoto_imgs}>
						<div className={s.realPhoto_imgWrapper}>
							<img className={s.realPhoto_imgWrapper_img} src={imgSrcBefore} alt='before' />
							<div className={s.realPhoto_weight}>{weightBefore}</div>
						</div>
						<div className={s.realPhoto_imgWrapper}>
							<img className={s.realPhoto_imgWrapper_img} src={imgSrcAfter} alt='after' />
							<div className={s.realPhoto_weight_after}>{weightAfter}</div>
						</div>
					</div>
					<div className={s.realPhoto_title}>
						<div>{titleMain}</div>
						<div className={s.realPhoto_lost}>{lost}</div>
					</div>
					<StarsRaiting stars={stars} />
					<div className={s.realPhoto_description}>{description}</div>
					<div className={s.realPhoto_data}>{data}</div>
				</div>
			)}
		</>
	);
});

export default RealPhoto;
